(function() {
  'use strict';

  /* --- Gallery state --- */
  var imgView = document.getElementById('ef-img-view');
  var modelView = document.getElementById('ef-model-view');
  var badges = document.getElementById('ef-pd-badges');
  var is3D = false;

  function showImg() {
    if (imgView) imgView.style.display = '';
    if (modelView) modelView.style.display = 'none';
    var videoView = document.getElementById('ef-video-view');
    if (videoView) { videoView.style.display = 'none'; videoView.innerHTML = ''; }
    var playOverlay = document.getElementById('ef-video-play-overlay');
    if (playOverlay) playOverlay.remove();
    var galleryMain = document.getElementById('ef-main-image');
    if (galleryMain) galleryMain.style.cursor = '';
    if (imgView) imgView.style.cursor = 'zoom-in';
    if (badges) badges.style.display = '';
    is3D = false;
  }
  function show3D() {
    if (imgView) imgView.style.display = 'none';
    if (modelView) modelView.style.display = '';
    var videoView = document.getElementById('ef-video-view');
    if (videoView) videoView.style.display = 'none';
    if (badges) badges.style.display = 'none';
    is3D = true;
  }
  function showVideo() {
    if (imgView) imgView.style.display = 'none';
    if (modelView) modelView.style.display = 'none';
    var videoView = document.getElementById('ef-video-view');
    if (videoView) videoView.style.display = '';
    if (badges) badges.style.display = 'none';
    is3D = false;
  }

  /* --- Update counter helper --- */
  function efUpdateCounter(idx, total) {
    var counter = document.getElementById('ef-pd-counter');
    if (counter) counter.textContent = (idx + 1) + ' / ' + total;
  }



  /* --- Build full image list from JSON (all product media) --- */
  var allImages = [];
  try {
    allImages = JSON.parse(document.getElementById('ef-all-media').textContent);
  } catch(e) {}
  var visibleThumbs = Array.from(document.querySelectorAll('.ef-pd-thumb'));
  /* If gallery auto-loaded with video first, sync currentImageIndex to video position */
  var currentImageIndex = 0;
  for (var _i = 0; _i < allImages.length; _i++) {
    if (allImages[_i] && allImages[_i].type === 'video') { currentImageIndex = _i; break; }
  }

  /* Preload all gallery images so rapid swipes hit the browser cache. */
  (function efPreloadGallery() {
    if (!Array.isArray(allImages)) return;
    allImages.forEach(function(m) {
      if (m && m.src && (!m.type || m.type === 'image')) {
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = m.src;
      }
    });
  })();

  /* --- Crossfade helper ---
     Token guards against rapid-swipe race: only the most recent decode()
     callback restores opacity. decode() waits for the new image to be
     paint-ready before swapping, eliminating "stuck on old frame" flicker. */
  var efCrossfadeToken = 0;
  function efCrossfade(src, alt) {
    var mainImg = document.getElementById('ef-main-img');
    if (!mainImg) return;
    if (mainImg.src === src) return;
    /* If <img> is wrapped in <picture>, the <source> element with srcset
       overrides <img src> on viewports matching its media query. On desktop
       ≥1025px the source loads the video preview frame, which makes <img src>
       changes invisible — gallery appears stuck on first frame.
       Remove any <source> elements on first navigation so subsequent src
       updates take visible effect.
       ALSO: the <img> itself has its own srcset (480/600/800/1000w of the
       featured image). When mainImg.src is updated, the browser keeps using
       the old srcset URLs and ignores the new src — gallery stays on first
       image. Clear srcset+sizes so src changes actually take effect.
       (Bug introduced 2026-04-30 when srcset was added for LCP optimization.) */
    var picParent = mainImg.parentElement;
    if (picParent && picParent.tagName === 'PICTURE') {
      picParent.querySelectorAll('source').forEach(function(s) { s.remove(); });
    }
    if (mainImg.srcset) mainImg.removeAttribute('srcset');
    if (mainImg.sizes) mainImg.removeAttribute('sizes');
    var token = ++efCrossfadeToken;
    mainImg.style.opacity = '0.35';
    var finish = function() {
      if (token !== efCrossfadeToken) return;
      mainImg.style.opacity = '1';
    };
    mainImg.alt = alt || '';
    if (mainImg.decode) {
      mainImg.src = src;
      mainImg.decode().then(finish).catch(finish);
    } else {
      mainImg.onload = finish;
      mainImg.onerror = finish;
      mainImg.src = src;
    }
  }

  /* --- Highlight the matching thumbnail and scroll it into view --- */
  function efHighlightThumb(index) {
    visibleThumbs.forEach(function(t) { t.classList.remove('is-active'); });
    var match = visibleThumbs.filter(function(t) {
      return parseInt(t.getAttribute('data-thumb-index'), 10) === index;
    })[0];
    if (match) {
      match.classList.add('is-active');
      match.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
    efUpdateThumbArrows();
  }

  /* --- Thumbnail strip scroll (desktop arrows) ---
     Uses scrollIntoView on a target thumb so rapid clicks compose deterministically.
     Smooth scrollBy can drop subsequent calls on some browsers when an animation
     is already running, which made the arrow feel "stuck". */
  var thumbRail = document.getElementById('ef-thumb-rail');
  window.efThumbScroll = function(dir) {
    if (!thumbRail) return;
    var thumbs = thumbRail.querySelectorAll('.ef-pd-thumb');
    if (!thumbs.length) return;
    var rect = thumbRail.getBoundingClientRect();
    var pageStep = 3;
    var target = null;
    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i].getBoundingClientRect();
      if (dir > 0 && t.right > rect.right + 1) { target = thumbs[Math.min(i + pageStep - 1, thumbs.length - 1)]; break; }
      if (dir < 0 && t.left < rect.left - 1) { target = thumbs[Math.max(i - pageStep + 1, 0)]; break; }
    }
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } else {
      thumbRail.scrollBy({ left: dir * 240, behavior: 'smooth' });
    }
    setTimeout(efUpdateThumbArrows, 350);
  };

  /* --- Show/hide thumb arrows based on scroll position --- */
  function efUpdateThumbArrows() {
    if (!thumbRail) return;
    var prevBtn = thumbRail.parentElement.querySelector('.ef-pd-thumb-arrow--prev');
    var nextBtn = thumbRail.parentElement.querySelector('.ef-pd-thumb-arrow--next');
    if (!prevBtn || !nextBtn) return;
    var atStart = thumbRail.scrollLeft <= 2;
    var atEnd = thumbRail.scrollLeft + thumbRail.clientWidth >= thumbRail.scrollWidth - 2;
    prevBtn.style.visibility = atStart ? 'hidden' : '';
    nextBtn.style.visibility = atEnd ? 'hidden' : '';
  }
  if (thumbRail) {
    thumbRail.addEventListener('scroll', efUpdateThumbArrows);
    /* Init on load */
    efUpdateThumbArrows();
  }

  /* --- Gallery thumbnail switching (crossfade) --- */
  window.efSwitchImage = function(thumb) {
    if (thumb.getAttribute('data-media-type') === 'model') return;
    showImg();
    efCrossfade(thumb.getAttribute('data-media-src'), thumb.getAttribute('data-media-alt') || '');
    currentImageIndex = parseInt(thumb.getAttribute('data-thumb-index'), 10);
    efHighlightThumb(currentImageIndex);
    efUpdateCounter(currentImageIndex, allImages.length);
  };

  /* --- Switch to 3D --- */
  window.efSwitch3D = function(thumb) {
    show3D();
    visibleThumbs.forEach(function(t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  };

  /* --- Switch to Video --- */
  window.efSwitchVideo = function(thumb) {
    var videoView = document.getElementById('ef-video-view');
    var galleryMain = document.getElementById('ef-main-image');
    var mediaIndex = thumb.getAttribute('data-media-index') || thumb.getAttribute('data-thumb-index');

    /* Find the hidden template with the Shopify-generated video tag */
    var template = document.querySelector('.ef-video-template[data-index="' + mediaIndex + '"]');

    if (template && videoView) {
      /* First show play overlay on current image */
      showImg();
      var previewSrc = thumb.querySelector('img') ? thumb.querySelector('img').src.replace('200x', '1200x') : '';
      if (previewSrc) {
        efCrossfade(previewSrc, 'Video preview');
      }

      /* Remove old play overlay if exists */
      var oldPlay = document.getElementById('ef-video-play-overlay');
      if (oldPlay) oldPlay.remove();

      /* Add play button overlay */
      var overlay = document.createElement('div');
      overlay.id = 'ef-video-play-overlay';
      overlay.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:5;background:rgba(0,0,0,0.15);transition:background 200ms;';
      overlay.innerHTML = '<div style="width:72px;height:72px;border-radius:50%;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;transition:transform 200ms,background 200ms;"><svg width="28" height="28" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="9,5 19,12 9,19"/></svg></div>';
      overlay.onmouseover = function() { overlay.style.background = 'rgba(0,0,0,0.25)'; overlay.firstChild.style.transform = 'scale(1.1)'; };
      overlay.onmouseout = function() { overlay.style.background = 'rgba(0,0,0,0.15)'; overlay.firstChild.style.transform = 'scale(1)'; };
      overlay.onclick = function(e) {
        e.stopPropagation();
        overlay.remove();
        showVideo();
        videoView.innerHTML = template.innerHTML;
        if (galleryMain) galleryMain.style.cursor = 'default';
      };
      if (galleryMain) {
        galleryMain.appendChild(overlay);
        galleryMain.style.cursor = 'default';
      }
    }

    currentImageIndex = parseInt(thumb.getAttribute('data-thumb-index'), 10);
    visibleThumbs.forEach(function(t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    efUpdateCounter(currentImageIndex, allImages.length);
  };

  /* --- Gallery arrow navigation (images only — skips videos & 3D models)
       Videos remain accessible via thumbnail click. The auto-loaded cover
       video sets currentImageIndex on load, but pressing next/prev jumps to
       the first/previous IMAGE rather than the next video. --- */
  window.efArrow = function(dir) {
    if (allImages.length < 2) return;
    var attempts = 0;
    do {
      currentImageIndex = (currentImageIndex + dir + allImages.length) % allImages.length;
      attempts++;
      var t = allImages[currentImageIndex] && allImages[currentImageIndex].type;
    } while ((t === 'model' || t === 'video' || t === 'external_video') && attempts < allImages.length);

    var next = allImages[currentImageIndex];
    if (!next) return;
    showImg();
    efCrossfade(next.src, next.alt);
    efHighlightThumb(currentImageIndex);
    efUpdateCounter(currentImageIndex, allImages.length);
  };

  /* --- Lightbox (click-to-zoom) — deferred until DOM ready --- */
  function efInitLightbox() {
    var lb = document.getElementById('ef-pd-lightbox');
    var lbImg = document.getElementById('ef-lb-img');
    var lbCounter = document.getElementById('ef-lb-counter');
    if (!lb || !lbImg) return;
    var lbIndex = 0;
    var imageList = allImages.filter(function(m) { return m.type === 'image'; });

    function lbOpen(idx) {
      lbIndex = idx;
      lbImg.src = imageList[lbIndex].src;
      lbImg.alt = imageList[lbIndex].alt;
      lbCounter.textContent = (lbIndex + 1) + ' / ' + imageList.length;
      lb.classList.add('ef-pd-lightbox--open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '-' + window.scrollY + 'px';
    }
    function lbClose() {
      var scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
      lb.classList.remove('ef-pd-lightbox--open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }
    function lbNav(dir) {
      lbIndex = (lbIndex + dir + imageList.length) % imageList.length;
      lbImg.style.opacity = '0';
      setTimeout(function() {
        lbImg.src = imageList[lbIndex].src;
        lbImg.alt = imageList[lbIndex].alt;
        lbCounter.textContent = (lbIndex + 1) + ' / ' + imageList.length;
        lbImg.style.opacity = '1';
      }, 150);
    }

    /* Bind lightbox-open ONLY to the image element (not the gallery container).
       This guarantees clicks on arrows / badges / video / 3D never trigger zoom,
       since those elements are siblings of #ef-main-img, not children. */
    var imgView = document.getElementById('ef-img-view');
    if (imgView) {
      imgView.addEventListener('click', function(e) {
        if (is3D) return;
        if (document.getElementById('ef-video-play-overlay') || (document.getElementById('ef-video-view') && document.getElementById('ef-video-view').style.display !== 'none')) return;
        var imgIdx = imageList.findIndex(function(m) { return m.src === document.getElementById('ef-main-img')?.src; });
        lbOpen(Math.max(0, imgIdx));
      });
    }

    document.getElementById('ef-lb-close').addEventListener('click', lbClose);
    document.getElementById('ef-lb-prev').addEventListener('click', function(e) { e.stopPropagation(); lbNav(-1); });
    document.getElementById('ef-lb-next').addEventListener('click', function(e) { e.stopPropagation(); lbNav(1); });
    lb.addEventListener('click', function(e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('ef-pd-lightbox--open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbNav(-1);
      if (e.key === 'ArrowRight') lbNav(1);
    });

    lbImg.style.transition = 'opacity 150ms ease';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', efInitLightbox);
  } else {
    setTimeout(efInitLightbox, 0);
  }

  /* --- Fireplace type card selector (visual only) --- */
  window.efSelectType = function(card) {
    var cards = document.querySelectorAll('.ef-pd-type-card');
    cards.forEach(function(c) { c.classList.remove('is-active'); });
    card.classList.add('is-active');
  };

  /* --- Swatch selector --- */
  window.efSelectSwatch = function(swatch, optionGroupIndex) {
    var parent = swatch.closest('.ef-pd-swatches');
    parent.querySelectorAll('.ef-pd-swatch').forEach(function(s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    var value = swatch.getAttribute('data-value');
    var label = document.getElementById('ef-swatch-selected-' + optionGroupIndex);
    if (label) label.textContent = value;

    /* Try to match a variant */
    efMatchVariant();
  };

  /* --- Match variant from swatch selections --- */
  function efMatchVariant() {
    var select = document.getElementById('ef-variant-select');
    if (!select) return;

    var selectedValues = [];
    document.querySelectorAll('.ef-pd-swatches').forEach(function(group) {
      var active = group.querySelector('.ef-pd-swatch.is-active');
      if (active) selectedValues.push(active.getAttribute('data-value'));
    });

    if (selectedValues.length === 0) return;

    for (var i = 0; i < select.options.length; i++) {
      var optText = select.options[i].textContent;
      var match = selectedValues.every(function(v) { return optText.indexOf(v) !== -1; });
      if (match) {
        select.selectedIndex = i;
        efVariantChange(select);
        break;
      }
    }
  }

  /* --- Variant change handler --- */
  window.efVariantChange = function(select) {
    var opt = select.options[select.selectedIndex];
    var price = opt.getAttribute('data-price');
    var available = opt.getAttribute('data-available') === 'true';
    var btn = document.getElementById('ef-atc-btn');
    var priceDisplay = document.getElementById('ef-price-display');
    var stickyPrice = document.getElementById('ef-sticky-price');

    if (priceDisplay) priceDisplay.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;

    if (btn) {
      if (available) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart \u2014 ' + price;
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold Out';
      }
    }

    /* Update URL without reload */
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
    }
  };

  /* --- Quantity +/- --- */
  window.efQty = function(delta) {
    var input = document.getElementById('ef-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = Math.max(1, Math.min(99, val + delta));
    input.value = val;
  };

  /* --- Accordion toggle ---
     Anchor scroll: when opening a tab, sibling tabs that close above the
     clicked one shrink the layout, pulling the trigger upward (or off-screen).
     The previous fix used requestAnimationFrame after a CSS transition, but
     the 350ms max-height animation meant the measured position was still
     mid-animation. Fix: close other tabs INSTANTLY (transition disabled),
     so layout settles synchronously, then measure + scroll-correct. */
  /* Initialize: any accordion item rendered with `is-open` from Liquid needs its
     body's inline max-height set to scrollHeight on load. Without this, the
     body has CSS max-height:0 (closed) but the item.classList says open — first
     click reads "open" → goes to close branch → no visible change → user must
     click twice. Sync DOM with markup state once on ready. */
  function efAccInitOpen() {
    document.querySelectorAll('.ef-pd-acc-item.is-open > .ef-pd-acc-body').forEach(function(body) {
      /* Pre-open accordions also need the lazy-image height fix — set to 'none'
         so they grow naturally as content/images load. 2026-05-06. */
      body.style.maxHeight = 'none';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', efAccInitOpen);
  } else {
    efAccInitOpen();
  }

  window.efAccToggle = function(trigger) {
    var item = trigger.closest('.ef-pd-acc-item');
    var body = item.querySelector('.ef-pd-acc-body');
    var isOpen = item.classList.contains('is-open');

    /* Closing the clicked tab — no anchor needed, just collapse.
       If max-height is currently 'none' (set after open completes — see below),
       re-lock to actual rendered height first so transition has a source value. */
    if (isOpen) {
      if (body.style.maxHeight === 'none' || body.style.maxHeight === '') {
        body.style.maxHeight = body.scrollHeight + 'px';
        void body.offsetHeight; /* force reflow so the lock commits before transition */
      }
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      requestAnimationFrame(function() {
        body.style.maxHeight = '0';
      });
      return;
    }

    /* OPENING — capture trigger position BEFORE any layout change */
    var beforeTop = trigger.getBoundingClientRect().top;

    /* Close all other open items INSTANTLY (no transition) so the layout
       contracts synchronously. Save + restore the transition so future
       toggles still animate normally. */
    document.querySelectorAll('.ef-pd-acc-item.is-open').forEach(function(other) {
      if (other === item) return;
      var otherBody = other.querySelector('.ef-pd-acc-body');
      var prevTrans = otherBody.style.transition;
      otherBody.style.transition = 'none';
      otherBody.style.maxHeight = '0';
      other.classList.remove('is-open');
      other.querySelector('.ef-pd-acc-trigger').setAttribute('aria-expanded', 'false');
      void otherBody.offsetHeight; /* force synchronous reflow so layout commits */
      requestAnimationFrame(function() { otherBody.style.transition = prevTrans; });
    });

    /* Open the clicked one (animated — body grows below trigger, doesn't
       affect trigger's Y position) */
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    body.style.maxHeight = body.scrollHeight + 'px';

    /* 2026-05-06 FIX — Installation Guide images are `loading="lazy"`. They
       load AFTER accordion opens, growing the content height. But max-height
       is locked at scrollHeight from the moment of opening → overflow:hidden
       cuts off bottom images. After the open transition completes, release
       the height limit so content flows naturally as images load.

       Also wire IntersectionObserver-style watch on lazy images: each one
       loaded re-grows scrollHeight, and with maxHeight:'none' the body
       expands accordingly. No extra JS recalc needed. */
    body.addEventListener('transitionend', function onOpenEnd(e) {
      if (e.propertyName !== 'max-height') return;
      body.removeEventListener('transitionend', onOpenEnd);
      if (item.classList.contains('is-open')) {
        body.style.maxHeight = 'none';
      }
    });

    /* Defensive fallback: if any image inside is still loading after
       transition might have fired (slow connection), force max-height:none
       once the last image settles. Covers older Safari quirks where
       transitionend doesn't fire reliably. */
    var imgs = body.querySelectorAll('img');
    imgs.forEach(function(img) {
      if (img.complete) return;
      img.addEventListener('load', function() {
        if (item.classList.contains('is-open') && body.style.maxHeight !== 'none') {
          body.style.maxHeight = 'none';
        }
      }, { once: true });
      img.addEventListener('error', function() {
        if (item.classList.contains('is-open') && body.style.maxHeight !== 'none') {
          body.style.maxHeight = 'none';
        }
      }, { once: true });
    });

    /* Layout has settled (others closed instantly). Measure trigger's new
       viewport position and scroll the page to keep it where the user
       clicked. Use the legacy 2-arg scrollBy — `behavior:'instant'` is not
       supported in older Safari and falls back to 'auto' (smooth-ish),
       which makes the correction visibly janky. */
    var afterTop = trigger.getBoundingClientRect().top;
    var delta = afterTop - beforeTop;
    if (Math.abs(delta) > 1) {
      window.scrollBy(0, delta);
    }
  };

  /* --- Mobile sticky ATC --- */
  window.efStickyAdd = function() {
    var mainBtn = document.getElementById('efCfgATC');
    if (mainBtn) {
      if (mainBtn.disabled) {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    }
  };

  /* --- Loox detection: hide fallback when Loox loads --- */
  (function() {
    var looxWrap = document.getElementById('loox-reviews');
    var fallback = document.getElementById('ef-rev-fallback');
    if (!looxWrap || !fallback) return;
    var observer = new MutationObserver(function() {
      if (looxWrap.children.length > 0) {
        fallback.style.display = 'none';
        observer.disconnect();
      }
    });
    observer.observe(looxWrap, { childList: true, subtree: true });
  })();

  /* --- Reviews carousel scroll --- */
  (function() {
    var track = document.getElementById('ef-rev-track');
    var prevBtn = document.getElementById('ef-rev-prev');
    var nextBtn = document.getElementById('ef-rev-next');
    if (!track) return;

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    window.efRevScroll = function(dir) {
      var card = track.querySelector('.ef-pd-review-card');
      var amount = card ? (card.offsetWidth + 18) : 320;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      setTimeout(updateArrows, 400);
    };

    track.addEventListener('scroll', updateArrows);
    updateArrows();
  })();

  /* --- Upsell carousel scroll --- */
  (function() {
    var track = document.getElementById('ef-upsell-track');
    var prevBtn = document.getElementById('ef-upsell-prev');
    var nextBtn = document.getElementById('ef-upsell-next');
    if (!track) return;

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    window.efUpsellScroll = function(dir) {
      var card = track.querySelector('.ef-pd-upsell-cv2-cell, .ef-pd-upsell-card');
      var amount = card ? (card.offsetWidth + 22) * 2 : 480;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      setTimeout(updateArrows, 400);
    };

    track.addEventListener('scroll', updateArrows);
    updateArrows();
  })();

  /* Mobile touch swipe support for main image */
  (function() {
    var galleryMain = document.getElementById('ef-main-image');
    if (!galleryMain) return;
    var startX = 0;
    var startY = 0;
    var isSwipe = false;
    /* Skip swipe handling when 3D model or video is active — those handle
       their own touch (model-viewer rotates the GLB on swipe; video has
       native controls). Without this guard, 3D rotation gestures on mobile
       were triggering image arrows and jumping to the next image. */
    function isModelOrVideoActive(target) {
      if (is3D) return true;
      var videoView = document.getElementById('ef-video-view');
      if (videoView && videoView.style.display !== 'none' && videoView.innerHTML) return true;
      if (target && target.closest && target.closest('model-viewer, model-media, #ef-model-view, #ef-video-view')) return true;
      return false;
    }
    galleryMain.addEventListener('touchstart', function(e) {
      if (isModelOrVideoActive(e.target)) { isSwipe = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwipe = true;
    }, { passive: true });
    /* Mobile fix 2026-04-28 v2: passive listener — browser GUARANTEES that
       preventDefault is ignored, so vertical scroll always works regardless
       of touch-action inheritance quirks (Samsung Internet doesn't propagate
       parent touch-action to child <img>). Swipe direction is detected at
       touchend via clientX delta — no preventDefault needed at any point. */
    galleryMain.addEventListener('touchend', function(e) {
      if (!isSwipe) return;
      isSwipe = false;
      if (isModelOrVideoActive(e.target)) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) efArrow(diff > 0 ? -1 : 1);
    });
  })();


  /* Sticky ATC controlled by ef-configurator.js — shows only on last step */

  /* Auto-launch AR from QR code (?ar=true) */
  (function() {
    if (new URL(window.location).searchParams.get('ar') !== 'true') return;
    history.replaceState(null, '', window.location.pathname + window.location.hash);

    function tryAR(attempt) {
      attempt = attempt || 0;
      var mv = document.querySelector('model-viewer');
      if (!mv) {
        var thumb3d = document.querySelector('.ef-pd-thumb--3d');
        if (thumb3d) thumb3d.click();
        setTimeout(function() { tryAR(attempt + 1); }, 800);
        return;
      }
      if (mv.canActivateAR) {
        mv.activateAR();
        return;
      }
      if (attempt < 15) {
        if (attempt === 0) {
          show3D();
          window.Shopify.loadFeatures([
            { name: 'shopify-xr', version: '1.0' },
            { name: 'model-viewer-ui', version: '1.0' }
          ]);
        }
        setTimeout(function() { tryAR(attempt + 1); }, 600);
      } else {
        show3D();
      }
    }

    if (document.readyState === 'complete') {
      setTimeout(function() { tryAR(0); }, 300);
    } else {
      window.addEventListener('load', function() { setTimeout(function() { tryAR(0); }, 300); });
    }
  })();

})();

/* ── Desktop video upgrade (v4 pattern) ──
   Mobile keeps the static <img id="ef-main-img"> (which uses the video preview frame
   as its src). Desktop after first paint: inject autoplay video into #ef-video-view,
   hide image view, show video view. Image and video share the same first frame so
   the swap is visually seamless. */
(function efDoorsUpgradeToVideoOnDesktop() {
  if (window.innerWidth < 1025) return;

  var galleryMain = document.getElementById('ef-main-image');
  if (!galleryMain) return;

  var videoIdx = parseInt(galleryMain.getAttribute('data-video-index'), 10);
  if (isNaN(videoIdx) || videoIdx < 0) return;

  var sourcesAttr = galleryMain.getAttribute('data-video-sources');
  if (!sourcesAttr) return;

  var sources;
  try { sources = JSON.parse(sourcesAttr); } catch (e) { return; }
  if (!sources || !sources.length) return;

  var poster = galleryMain.getAttribute('data-video-poster') || '';

  var trigger = function() {
    var imgView = document.getElementById('ef-img-view');
    var videoView = document.getElementById('ef-video-view');
    var badges = document.getElementById('ef-pd-badges');
    var modelView = document.getElementById('ef-model-view');
    if (!videoView) return;
    /* Bail if user has already navigated to another media */
    if (videoView.style.display !== 'none' && videoView.style.display !== '') return;
    if (modelView && modelView.style.display !== 'none' && modelView.style.display !== '') return;

    /* Build video element programmatically */
    var v = document.createElement('video');
    v.id = 'ef-video-autoplay';
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.autoplay = true;
    v.preload = 'metadata';
    v.poster = poster;
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
    v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;background:#1A1410;';
    sources.forEach(function(s) {
      var src = document.createElement('source');
      src.src = s.url;
      src.type = s.mime;
      v.appendChild(src);
    });
    videoView.innerHTML = '';
    videoView.appendChild(v);
    v.play().catch(function(){});

    /* Toggle views */
    if (imgView) imgView.style.display = 'none';
    videoView.style.display = '';
    if (badges) badges.style.display = 'none';

    /* Update counter to video index */
    var counter = document.getElementById('ef-pd-counter');
    if (counter) {
      var totalMedia = document.querySelectorAll('.ef-pd-thumb').length || (videoIdx + 1);
      counter.textContent = (videoIdx + 1) + ' / ' + totalMedia;
    }

    /* Sync active thumb */
    document.querySelectorAll('.ef-pd-thumb').forEach(function(t) {
      t.classList.remove('is-active');
      if (parseInt(t.getAttribute('data-thumb-index'), 10) === videoIdx ||
          parseInt(t.getAttribute('data-media-index'), 10) === videoIdx) {
        t.classList.add('is-active');
      }
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(trigger, { timeout: 1500 });
  } else {
    setTimeout(trigger, 800);
  }
})();
